(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (!productRecommendationsSection) return;

    // Read product id and limit from data attributes
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var recommendedUrl = productRecommendationsSection.dataset.baseUrl;

    if (!recommendedUrl) return;

    // Build request URL
    var requestUrl = `${recommendedUrl}?section_id=product-recommendations&limit=${limit}&product_id=${productId}`;

    // Fetch recommendations using XMLHttpRequest
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;

        // Replace content with the fetched recommendations
        productRecommendationsSection.parentElement.innerHTML = 
          container.querySelector(".product-recommendations").innerHTML;

        // Initialize carousel after recommendations are loaded
        initializeProductCarousel();
      }
    };
    request.send();
  };

  var initializeProductCarousel = function() {
    var $carousel = $('.product-carousel');
    if ($carousel.length) {
      $carousel.not('.slick-initialized').slick({
        infinite: true,
        autoplaySpeed: 4000,
        lazyLoad: "progressive",
        speed: 600,
        arrows: true,
        nextArrow: '<a class="slick-next slick-arrow"><i class="la la-angle-right" aria-hidden="true"></i></a>',
        prevArrow: '<a class="slick-prev slick-arrow"><i class="la la-angle-left" aria-hidden="true"></i></a>',
        slidesToShow: 4,
        slidesToScroll: 2,
        responsive: [
          {
            breakpoint: 740,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      });

      // Recalculate carousel dimensions when images are lazyloaded
      document.addEventListener('lazyloaded', function() {
        $carousel.slick('setPosition');
      });
    }
  };

  // Fetch recommendations on page load
  loadProductRecommendationsIntoSection();

  // Re-fetch and initialize carousel when a section is loaded
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
